import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@coin-depo-config/environments/core-env/environment';

import * as Sentry from "@sentry/angular";

import { SENTRY_IGNORE_ERRORS } from './app/user-api/sentry-noise';

Sentry.init({
  dsn: "https://ab38b538502c801a7dd6e9fd88fe76e4@o4510317109772288.ingest.de.sentry.io/4510973153771600",
  // Setting this option to true will send default PII data to Sentry.
  // automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.05, //  Capture 5% of the transactions
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // "localhost", // If allow locally
    // /^https:\/\/dev-app.coindepo\.io\/api/,
    // /^https:\/\/stage-app.coindepo\.io\/api/,
    /^https:\/\/api\.coindepo\.com/,
  ],
  // Enable sending logs to Sentry
  enableLogs: true,
  // N2: drop transient status-0 network aborts that reach the global
  // ErrorHandler as a string. See sentry-noise.ts for the rationale.
  ignoreErrors: SENTRY_IGNORE_ERRORS
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
